import { render, staticRenderFns } from "./ShareEarnModalPage.vue?vue&type=template&id=6bdc34a8&scoped=true"
import script from "./ShareEarnModalPage.vue?vue&type=script&lang=js"
export * from "./ShareEarnModalPage.vue?vue&type=script&lang=js"
import style0 from "./ShareEarnModalPage.vue?vue&type=style&index=0&id=6bdc34a8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6bdc34a8",
  null
  
)

export default component.exports